module.exports = __webpack_public_path__ + "static/media/20170825_194309.6d2309bd.jpg";